import { CF_TURNSTILE_SITEKEY } from '$services/environments'
import { ButtonProps } from '@genie-fintech/ui/components'

export const APP_TOKEN_KEY = 'app-token'

export const TOOLTIP_ID = 'r-tooltip'

export const ACL_OPTIONS = [
  { value: 'role_based', label: 'ROLE BASED' },
  { value: 'permission_based', label: 'PERMISSION BASED' }
]

export const INNER_HEADER_ID = 'inner-header'

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' }
]

export const USER_STATUS_TABS = [
  { label: 'ACTIVE', value: 'active' },
  { label: 'INACTIVE', value: 'inactive' }
]

export const APP_ENVIRONMENT_OPTIONS = [
  {
    key: 1,
    value: 'development'
  },
  {
    key: 2,
    value: 'local'
  },
  {
    key: 3,
    value: 'staging'
  },
  {
    key: 4,
    value: 'uat'
  },
  {
    key: 5,
    value: 'production'
  }
]

export const MIN_PWD_LENGTH = 6

export const MAX_PWD_LENGTH = 255

export const ALLOWED_SPECIAL_CHARACTERS = [
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*'
]

export const DATE_FORMAT_WITH_TIMEZONE = 'dd MMM yyyy, hh:mma z'

export enum PERMISSIONS {
  APPLICATION_LIST = 'application:list',
  APPLICATION_CREATE = 'application:create',
  APPLICATION_DELETE = 'application:delete',
  APPLICATION_PUBLISH = 'application:publish',

  APPLICATION_VIEW_BASIC = 'application:view-basic',
  APPLICATION_EDIT_BASIC = 'application:edit-basic',

  APPLICATION_VIEW_ADVANCED = 'application:view-advanced',
  APPLICATION_EDIT_ADVANCED = 'application:edit-advanced',

  APPLICATION_VIEW_LAUNCHPAD = 'application:view-launchpad',
  APPLICATION_EDIT_LAUNCHPAD = 'application:edit-launchpad',

  APPLICATION_VIEW_GROUP = 'application:group:view',
  APPLICATION_GROUP_ADD = 'application:group:add',
  APPLICATION_GROUP_EDIT = 'application:group:edit',
  APPLICATION_GROUP_DELETE_ = 'application:group:delete',

  APPLICATION_USER_VIEW = 'application:user:view',
  APPLICATION_USER_ADD = 'application:user:add',
  APPLICATION_USER_IMPORT = 'application:user:import',
  APPLICATION_USER_EDIT = 'application:user:edit',
  APPLICATION_USER_REMOVE = 'application:user:remove',
  APPLICATION_USER_BAN = 'application:user:ban',

  APPLICATION_ROLE_VIEW = 'application:role:view',
  APPLICATION_ROLE_ADD = 'application:role:add',
  APPLICATION_ROLE_IMPORT = 'application:role:import',
  APPLICATION_ROLE_EDIT = 'application:role:edit',
  APPLICATION_ROLE_DELETE = 'application:role:delete',

  APPLICATION_PERMISSION_VIEW = 'application:permission:view',
  APPLICATION_PERMISSION_ADD = 'application:permission:add',
  APPLICATION_PERMISSION_IMPORT = 'application:permission:import',
  APPLICATION_PERMISSION_EDIT = 'application:permission:edit',
  APPLICATION_PERMISSION_DELETE = 'application:permission:delete',

  APPLICATION_MANAGE_KEYS = 'application:manage-keys',
  APPLICATION_MANAGE_WEBHOOKS = 'application:manage-webhooks',

  TENANTS_MANAGE = 'tenants:manage',
  TENANTS_MANAGE_DOMAINS = 'tenants:manage-domains',
  TENANTS_MANAGE_MEMBERS = 'tenants:manage-members',

  COUNTRY_CREATE = 'country:create',
  COUNTRY_VIEW = 'country:view',
  COUNTRY_EDIT = 'country:edit',
  COUNTRY_DELETE = 'country:delete',

  GLOBAL_EDIT_PASSWORD_POLICY = 'global:edit-password-policy',

  USER_LIST = 'user:list',
  USER_VIEW = 'user:view',
  USER_BAN = 'user:ban',

  USER_BASIC_INFO_VIEW = 'user:basic-info:view',
  USER_BASIC_INFO_EDIT = 'user:basic-info:edit',
  USER_PHONE_NUMBER_VIEW = 'user:phone-number:view',
  USER_PHONE_NUMBER_EDIT = 'user:phone-number:edit',
  USER_EMAIL_VIEW = 'user:email:view',
  USER_EMAIL_EDIT = 'user:email:edit',

  USER_PASSWORD_SETTING_VIEW = 'user:password-setting:view',
  USER_PASSWORD_SETTING_EDIT = 'user:password-setting:edit',
  USER_MFA_SETTING_VIEW = 'user:mfa-setting:view',
  USER_MFA_SETTING_EDIT = 'user:mfa-setting:edit',
  USER_ATTACK_PROTECTION_VIEW = 'user:attack-protection:view',
  USER_ATTACK_PROTECTION_EDIT = 'user:attack-protection:edit',

  MEMBER_LIST = 'member:list',
  MEMBER_VIEW = 'member:view',
  MEMBER_EDIT = 'member:edit',
  MEMBER_DELETE = 'member:delete',
  MEMBER_BAN = 'member:ban',
  MEMBER_CREATE = 'member:create',
  MEMBER_ADD_USER_APPS = 'member:add-user-apps',
  MEMBER_MANAGE_SERVICE = 'member:manage-service',
  MEMBER_MANAGE = 'member:manage',
  MEMBER_MANAGE_SERVICE_PASSWORDS = 'member:manage-service-passwords'
}

export enum ACTIVITY_ACTION {
  UNLOCK_USER_FAILED_LOGIN = 'unlock_user_failed_login'
}

export const CF_TURNSTILE_HEADER_KEY = 'X-CF-Turnstile-Response'
export const CF_TURNSTILE_ENABLED = !!CF_TURNSTILE_SITEKEY

export const GENERAL_TIME_FORMAT_WITH_TIMEZONE = 'dd MMM yyyy, hh:mma z'

export type TDevice = (typeof DEVICES)[number]

export const DEVICES = [
  'mobile',
  'desktop',
  'tablet',
  'api-client-tools',
  'robot',
  'unknown'
] as const

export const outlineNeutralButtonVariant: ButtonProps['styleVariants'] = {
  size: 'small',
  type: 'outlined',
  kind: 'neutral'
}

export const THEME_NAME = import.meta.env.VITE_THEME_NAME || 'carro'

export const DEFAULT_PHONE_CODE = (() => {
  const data: Record<typeof THEME_NAME, string> = {
    carro: '+66',
    motto: '+65'
  }
  return data[THEME_NAME]
})()
